import type { InviteUserToWorkspace } from '@ditto/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthenticatedClient } from './useApi';

export const useInviteUserToWorkspaceApi = () => {
  const { client } = useAuthenticatedClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (inviteData: InviteUserToWorkspace) => {
      const response = await client.settings.inviteUserToWorkspace({
        body: inviteData,
      });

      if (response.status === 200) {
        return response.body;
      }

      const errorMessage =
        (response.body as any)?.message ||
        `Request failed with status ${response.status}`;
      const error = new Error(errorMessage);
      (error as any).response = response;
      throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['workspaces'] });
      queryClient.invalidateQueries({ queryKey: ['back-office-workspaces'] });
      queryClient.invalidateQueries({ queryKey: ['back-office-users'] });
    },
  });
};

export const useRemoveUserFromWorkspaceApi = () => {
  const { client } = useAuthenticatedClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (memberId: string) => {
      const response = await client.settings.removeUserFromWorkspace({
        params: { memberId },
        body: undefined as never,
      });

      if (response.status === 200) {
        return response.body;
      }

      const errorMessage =
        (response.body as any)?.message ||
        `Request failed with status ${response.status}`;
      const error = new Error(errorMessage);
      (error as any).response = response;
      throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['workspaces'] });
    },
  });
};
